<template>
  <v-row>
    <ResumeProcessQuotation
      :form="currentQuotationToEdit"
      v-if="show"
      @return="previousPage"
    />
  </v-row>
</template>
<script>
import ResumeProcessQuotation from "../components/ResumeProcessQuotation";
import { mapActions, mapState } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
export default {
  data: () => ({
    show: false
  }),
  components: {
    ResumeProcessQuotation
  },
  mixins: [LoadingRequest],
  created() {
    this.fetchEditQuotation();
  },
  computed: {
    ...mapState("quotation", ["currentQuotationToEdit"])
  },
  methods: {
    ...mapActions("quotation", ["requestCurrentQuotationToEdit"]),
    fetchEditQuotation() {
      this.withLoading(
        this.requestCurrentQuotationToEdit(this.$route.params.id)
      );
    },
    previousPage() {
      this.$emit("return");
    }
  }
};
</script>
